import { NavigationGuardNext, Route } from 'vue-router';

import store from '@/store';
import { PERMISSION_NAME_BY_DEGREE_ID } from '@/constant/PermissionBookByDegreeID';
import { LIST_PERMISSION } from '@/constant/ListPermission';
import { LIST_PLAN_ID } from '@/constant/PlansIDs';

import BookService from '@/services/Book/BookService';

import { Book, Degree } from '@/globalInterfaces/Book';

import Permission from './index';

const bookService = new BookService();
const PermissionClass = new Permission();

const CONTEXT_BOOK = 'caderno';
const NOT_FOUND = -1;

function getDegreeIDsWithPermission(degrees: Degree[]) {
  const degreesWithPermission = degrees
    .filter((degree: Degree) => PermissionClass.can(PERMISSION_NAME_BY_DEGREE_ID[degree.ID]))
    .map((degree: Degree) => degree.ID);

  return degreesWithPermission;
}

async function getDegreeIDs() {
  let degreesWithPermission: number[] = [];

  try {
    const degrees = await bookService.getDegrees();

    degreesWithPermission = getDegreeIDsWithPermission(degrees);
  } catch (error) {
    console.error(error);
  }

  return degreesWithPermission;
}

async function findPermissionDegreeID() {
  const degreesWithPermission = await getDegreeIDs();

  return degreesWithPermission;
}

async function verifyBookPermission(permissionsDegreeIDs: number[], to: Route) {
  let bookFound = NOT_FOUND;

  try {
    const { path } = to.params;

    const allDegreeBooksWithPermission: Book[] = await bookService.books(
      permissionsDegreeIDs,
      store.getters.profile?.institution?.id
    );

    bookFound = allDegreeBooksWithPermission && allDegreeBooksWithPermission.length
      ? allDegreeBooksWithPermission.findIndex((book: Book) => book.slug === path)
      : NOT_FOUND;
  } catch (error) {
    console.error(error);
  }

  return bookFound !== NOT_FOUND;
}

export async function permissionBookFeature(
  to: Route,
  from: Route,
  next: NavigationGuardNext<Vue>
) {
  const hasPermissionInHighSchool = PermissionClass.can(LIST_PERMISSION.BOOKS_DEGREE_HIGH_SCHOOL);

  const { context } = to.params;

  if (context && context !== CONTEXT_BOOK && hasPermissionInHighSchool) {
    next();
    return;
  }

  const listPermissionsDegreeID = await findPermissionDegreeID();

  const hasPermissionBook = await verifyBookPermission(listPermissionsDegreeID, to);

  if (hasPermissionBook) {
    next();
    return;
  }

  next({
    name: 'Dashboard'
  });
}

function findNextAvailablePage(): string | null {

  const pages = [
    { permission: LIST_PERMISSION.COURSE, route: 'Courses' },
    { permission: LIST_PERMISSION.WAR, route: 'Welcome' },
    { permission: LIST_PERMISSION.PLANNER, route: 'Planner' },
    { permission: LIST_PERMISSION.REDACTION_FEATURE, route: 'Redaction' },
    { permission: LIST_PERMISSION.DOUBTS_FEATURE, route: 'ShowDoubts' },
    { permission: LIST_PERMISSION.DB_QUESTIONS, route: 'ListQuestions' },
    { permission: LIST_PERMISSION.SIMULATION, route: 'SimulationsList' },
    { permission: LIST_PERMISSION.EXAMS, route: 'Exam' },
    { permission: LIST_PERMISSION.CLASSES, route: 'Classes' },
    { permission: LIST_PERMISSION.CALENDAR, route: 'calendario' },
    { permission: LIST_PERMISSION.MESSAGES, route: 'mensagens' },
    { permission: LIST_PERMISSION.HELP, route: 'faq' },
    { permission: LIST_PERMISSION.GRADES, route: 'notas' }
  ];

  const page = pages.find(({ permission }) => PermissionClass.can(permission));
  return page ? page.route : null;
}

export function permissionBooks(to: Route, from: Route, next: NavigationGuardNext<Vue>) {

  const isBooks = PermissionClass.can(LIST_PERMISSION.BOOKS);
  const isPlanFree = store.getters.profile?.plan?.planID === LIST_PLAN_ID.FREE;

  const hasAccess = isBooks || isPlanFree;

  if (hasAccess) {
    next(); 
    return;
  }

  const nextPage = findNextAvailablePage();

  if (nextPage) {
    next({ name: nextPage });
  } else {
    next({ name: 'feedkback' });
  }
}
